"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
interface StepItem {
  number: string;
  title: string;
  detail: string;
}
const STEPS: StepItem[] = [{
  number: "01",
  title: "SOURCE",
  detail: "You send stock or request"
}, {
  number: "02",
  title: "MATCH",
  detail: "We connect buyer & supplier"
}, {
  number: "03",
  title: "CLOSE",
  detail: "Deal executed fast"
}];
export default function WhyHow() {
  const shouldReduceMotion = useReducedMotion();
  const initialAnim = shouldReduceMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 24
  };
  const viewAnim = {
    opacity: 1,
    y: 0
  };
  const transitionConfig = {
    duration: 0.5,
    ease: "easeOut" as const
  };
  return <section id="whyandhowktex" data-nav="light" className="relative w-full bg-background text-foreground py-20 lg:py-28 overflow-hidden isolate">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* How KTEX Works Process */}
        <motion.div initial={initialAnim} whileInView={viewAnim} viewport={{
        once: true,
        amount: 0.2
      }} transition={transitionConfig} className="rounded-2xl border border-border bg-muted/30 p-8 sm:p-12 lg:p-16 relative">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <Badge variant="outline" className="mb-4 text-xs font-semibold uppercase tracking-wider">
              Operational Roadmap
            </Badge>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground mb-3">
              How KTEX Works
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground">
              Direct, transparent trade execution from request to delivery.
            </p>
          </div>

          {/* Stepper with connecting line */}
          <div className="relative">
            {/* Central horizontal line for desktop */}
            <div aria-hidden="true" className="hidden lg:block absolute top-7 left-12 right-12 h-0.5 bg-border -z-0" />

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-8 lg:gap-6 relative z-10">
              {STEPS.map((step, i) => <motion.div key={step.number} data-index={i} initial={initialAnim} whileInView={viewAnim} viewport={{
              once: true,
              amount: 0.2
            }} transition={{
              duration: 0.5,
              delay: shouldReduceMotion ? 0 : i * 0.12,
              ease: "easeOut"
            }} className="flex flex-col items-center text-center group">
                  {/* Circular step badge */}
                  <div className="size-14 rounded-full bg-primary text-primary-foreground font-bold text-base flex items-center justify-center shadow-sm ring-4 ring-background mb-5 transition-[transform,box-shadow] duration-200 group-hover:scale-105 group-hover:shadow-md">
                    {step.number}
                  </div>

                  <h3 className="text-base font-bold tracking-wider text-foreground uppercase mb-2">
                    {step.number} {step.title}
                  </h3>

                  <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
                    {step.detail}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}